"use client";

import { c as _c } from "react/compiler-runtime";
import { useTransition } from "react";
import { useRouter } from "next/navigation";
import { toast } from "sonner";
import { endImpersonation } from "@/app/actions/admin/impersonation-actions";

/**
 * The one way out of an impersonation session, shared by the banner and the
 * read-only notices (AIR-1435) so every "Exit impersonation" button lands the
 * admin in the same place: back on the admin console with the page re-rendered
 * without the impersonation cookie.
 */
export function useEndImpersonation() {
  const $ = _c(5);
  const router = useRouter();
  const [isPending, startTransition] = useTransition();
  let t0;
  if ($[0] !== router) {
    t0 = () => {
      startTransition(async () => {
        const result = await endImpersonation();
        if (result.success) {
          toast.success("Impersonation ended");
          router.push("/admin");
          router.refresh();
        } else {
          toast.error(result.error);
        }
      });
    };
    $[0] = router;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const exitImpersonation = t0;
  let t1;
  if ($[2] !== exitImpersonation || $[3] !== isPending) {
    t1 = {
      exitImpersonation,
      isPending
    };
    $[2] = exitImpersonation;
    $[3] = isPending;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}